import React, { useState, useEffect } from "react";
import {
  AppBar,
  Avatar,
  Divider,
  List,
  ListItemButton,
  Toolbar,
} from "@mui/material";
import Box from "@mui/material/Box";
// import avatar from '../img/avatar.png'
import { Button, Col } from "react-bootstrap";
import {
  IoHomeOutline,
  IoLayersOutline,
  IoBookmarksOutline,
  IoPersonOutline,
} from "react-icons/io5";
import { RxDashboard } from "react-icons/rx";

import { FaUber } from "react-icons/fa";
import { FaRedRiver } from "react-icons/fa";
import { AiOutlineReconciliation } from "react-icons/ai";
// import { GrUserManager } from "react-icons/gr";
import { GoChecklist } from "react-icons/go";
import { TbSend } from "react-icons/tb";
import { ImFilesEmpty, ImLocation2 } from "react-icons/im";
import { FcBusinessman } from "react-icons/fc";
import styled from "styled-components";
import { useNavigate } from "react-router";
import {
  Accounts,
  Billing_Details,
  BillReportData,
  DailyReportData,
  FundReportData,
  OpretionReportData,
  PaymentEstimationData,
  Place,
  SidebarData,
  PaymentExpencesData,
} from "./sidebar/SidebarData";
import SubMenu from "./sidebar/SubMenu";
import {
  getplaceSession,
  getUser,
  getUserTypeSession,
  setUserSession,
  removeUserSession,
} from "../Utils/Common";
import { ImSwitch } from "react-icons/im";
import { BiChevronsDown, BiMenu } from "react-icons/bi";
import AuthenticationService from "../../Services/AuthenticationService";
import IdleTimerContainer from "../IdleTimerContainer";

const SidebarNav = styled.nav`
  font-wight: 500;
  width: 290px;
  height: 100vh;
  position: fixed;
  z-index: 10;
  box-shadow: 0 16px 15px 15px rgb(126 55 216 / 3%);

  top: 10;
  left: ${({ sidebar }) => (sidebar ? "2.5%" : "-100%")};
  transition: "25s";
  transition-delay: "revert-layer";
  z-index: 10;
`;
const SidebarNav1 = styled.nav`
  font-wight: 500;
  width: 420px;
  height: 100vh;
  position: fixed;
  z-index: 10;
  box-shadow: 0 16px 15px 15px rgb(126 55 216 / 3%);

  top: 10;
  left: ${({ sidebar }) => (sidebar ? "2.5%" : "-100%")};
  transition: "25s";
  transition-delay: "revert-layer";
  z-index: 10;
`;
const SidebarNav2 = styled.nav`
  font-wight: 500;
  width: 310px;
  height: 100vh;
  position: fixed;
  z-index: 10;
  box-shadow: 0 16px 15px 15px rgb(126 55 216 / 3%);

  top: 10;
  left: ${({ sidebar }) => (sidebar ? "2.5%" : "-100%")};
  transition: "25s";
  transition-delay: "revert-layer";
  z-index: 10;
`;
const SidebarNav3 = styled.nav`
  font-wight: 500;
  width: 290px;
  height: 100vh;
  position: fixed;
  z-index: 10;
  box-shadow: 0 16px 15px 15px rgb(126 55 216 / 3%);

  top: 10;
  left: ${({ sidebar }) => (sidebar ? "2.5%" : "-100%")};
  transition: "25s";
  transition-delay: "revert-layer";
  z-index: 10;
`;
const SidebarNav4 = styled.nav`
  font-wight: 500;
  width: 290px;
  height: 100vh;
  position: fixed;
  z-index: 10;
  box-shadow: 0 16px 15px 15px rgb(126 55 216 / 3%);

  top: 10;
  left: ${({ sidebar }) => (sidebar ? "2.5%" : "-100%")};
  transition: "25s";
  transition-delay: "revert-layer";
  z-index: 10;
`;
function Home(props) {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = React.useState(3);

  const [placevisible, setplacevisible] = useState(true);
  const [billRepvisible, setbillRepvisible] = useState(true);
  const [Billreports_hidden, setBillreports_hidden] = useState(false);
  const [billing_edit_hidden, setbilling_edit_hidden] = useState(false);
  const [billing_hidden, setbilling_hidden] = useState(false);
  const [fundRepvisible, setfundRepvisible] = useState(true);
  const [dailyStsRepvisible, setdailyStsRepvisible] = useState(true);
  const [operRepvisible, setoperRepvisible] = useState(true);
  const [billvisible, setbillvisible] = useState(true);
  const [acc_visible, setacc_visible] = useState(true);

  const placeBarOnclick = () => {
    setplacevisible(!placevisible);
    setbillRepvisible(true);
    setfundRepvisible(true);
    setdailyStsRepvisible(true);
    setoperRepvisible(true);
    setbillvisible(true);
    setacc_visible(true);
  };
  const BillRepOnclick = () => {
    setbillRepvisible(!billRepvisible);
    setplacevisible(true);
    setfundRepvisible(true);
    setdailyStsRepvisible(true);
    setoperRepvisible(true);
    setbillvisible(true);
    setacc_visible(true);
  };
  const FundRepOnclick = () => {
    setfundRepvisible(!fundRepvisible);
    setplacevisible(true);
    setbillRepvisible(true);
    setdailyStsRepvisible(true);
    setoperRepvisible(true);
    setbillvisible(true);
    setacc_visible(true);
  };
  const DailyRepOnclick = () => {
    setdailyStsRepvisible(!dailyStsRepvisible);
    setplacevisible(true);
    setbillRepvisible(true);
    setfundRepvisible(true);
    setoperRepvisible(true);
    setbillvisible(true);
    setacc_visible(true);
  };
  const OprRepOnclick = () => {
    setoperRepvisible(!operRepvisible);
    setplacevisible(true);
    setbillRepvisible(true);
    setfundRepvisible(true);
    setdailyStsRepvisible(true);
    setbillvisible(true);
    setacc_visible(true);
  };
  const dSR4RepOnclick = () => {
    setoperRepvisible(true);
    navigate("/DSR");
    setplacevisible(true);
    setbillRepvisible(true);
    setfundRepvisible(true);
    setdailyStsRepvisible(true);
    setbillvisible(true);
    setacc_visible(true);
  };
  const BillingBarOnclick = () => {
    setbillvisible(!billvisible);
    setplacevisible(true);
    setbillRepvisible(true);
    setfundRepvisible(true);
    setdailyStsRepvisible(true);
    setoperRepvisible(true);
    setacc_visible(true);
  };
  const AccBarOnclick = () => {
    setacc_visible(!acc_visible);
    setplacevisible(true);
    setbillRepvisible(true);
    setfundRepvisible(true);
    setdailyStsRepvisible(true);
    setoperRepvisible(true);
    setbillvisible(true);
  };

  const [Genarel, setGenarel] = useState(false);
  const [Report, setReport] = useState(false);
  const [paymentExpence, setpaymentExpence] = useState(false);
  const [Fund, setFund] = useState(false);
  const [Master, setMaster] = useState(false);
  // const open = Boolean(anchorEl);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
    if (index === 0) {
      setGenarel(!Genarel);
      setReport(false);
      setFund(false);
      setMaster(false);
      setpaymentExpence(false);
    } else if (index === 1) {
      setGenarel(false);
      setReport(false);
      setFund(!Fund);
      setpaymentExpence(false);
      setMaster(false);
    } else if (index === 11) {
      setGenarel(false);
      setReport(false);
      setFund(false);
      setpaymentExpence(!paymentExpence);
      setMaster(false);
    } else if (index === 2) {
      setGenarel(false);
      setFund(false);
      setpaymentExpence(false);
      if (
        getUserTypeSession() === "Accounts_admin" ||
        getUserTypeSession() === "ACCOUNTS"
      ) {
        setBillreports_hidden(false);
      } else {
        setBillreports_hidden(true);
      }
      setReport(!Report);
      setMaster(false);
    } else if (index === 3) {
      setMaster(!Master);
      setGenarel(false);
      setFund(false);
      setReport(false);
      setpaymentExpence(false);
    } else if (index === 4) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false);
      navigate("/CustomActivity");
      setpaymentExpence(false);
    } else if (index === 5) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false);
      navigate("/BeSbUpdation");
      setpaymentExpence(false);
    } else if (index === 6) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false);
      setpaymentExpence(false);
      navigate("/Tracking");
    } else if (index === 7) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false);
      setpaymentExpence(false);
      navigate("/checklistApprovalbMngr");
    } else if (index === 8) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false);
      setpaymentExpence(false);
      navigate("/checklistSndParty");
    } else if (index === 9) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false);
      setpaymentExpence(false);
      navigate("/checklistVerify");
    } else if (index === 10) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false);
      setpaymentExpence(false);
      navigate("/billedit");
    } else if (index === 12) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false);
      setpaymentExpence(false);
      navigate("/home");
    }
    // onmouseleave(handleClosesidebar(event))
  };

  // const handleMenu = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  const handleClosesidebar = (e) => {
    setMaster(false);
    setGenarel(false);
    setFund(false);
    setReport(false);
  };
  // const hideAndShowNav = () => {
  //   setMenubar(!menuBar);
  //   setGenarel(false);
  // }

  const menu_velidete = async () => {
    if (getUserTypeSession() === "Accounts_admin") {
      setbilling_hidden(false);
    } else {
      setbilling_hidden(true);
    }
    if (getUserTypeSession() === "billing_admin") {
      setbilling_edit_hidden(false);
    } else {
      setbilling_edit_hidden(true);
    }
  };

  const loginPage = (e) => {
    // Call Authentication service
    AuthenticationService.executeJwtAuthenticationService()
      .then((response) => {
        // console.log('APILogin=>' + JSON.stringify("Barear " + response.data.token));
        setUserSession("Bearer " + response.data.token, getUser());
        // setUserSession("Bearer ", values.txt_userName)
        // AuthenticationService.registerSuccessfulLoginForJwt(values.txt_userName,response.data.token);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    setTimeout(() => {
      loginPage();
    }, 16000000);
    menu_velidete();
  }, []);

  const logout = () => {
    removeUserSession(); // ✅ clears token, userId, etc.
    navigate("/"); // ✅ redirect to login
  };
  const home = () => {
    navigate("/home");
  };
  return (
    <div>
      <IdleTimerContainer />
      <div style={{ marginBottom: "130px" }}>
        <Box sx={{ flexGrow: 1 }}>
          <AppBar variant="elevation" position="fixed">
            <Toolbar className="tabsCss">
              <BiMenu onClick={home} fontSize={20} />
              &nbsp;
              <h4 className="ngptxt m-2">
                NGP CHA
                <span className="spancss">
                  Specific Integrated Logistics Solutions
                </span>
              </h4>
              &nbsp;&nbsp;
              <Box sx={{ flexGrow: 1 }} />
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <label className="UserCss"> {getUser()}</label>&nbsp;
                <Avatar sx={{ width: 24, height: 24 }}>
                  <FcBusinessman />
                </Avatar>
                &nbsp;
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                ></Divider>
                &nbsp;
                <label className="placecss"> {getplaceSession()}</label>
                <ImLocation2 style={{ color: "green" }} fontSize={19} />
                &nbsp;
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                ></Divider>
                &nbsp;&nbsp;&nbsp;
              </Box>
              <button className="lgbtncss" onClick={logout}>
                <span className="logoutBtn">
                  <ImSwitch />
                </span>
              </button>
              {/* <Typography variant="h6" component="div" sx={{flexGrow:1}}> </Typography>
            <span><BiCalendar/> {dateState.toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                })} <BiAlarm/> {dateState.toLocaleString('en-US', {
                  hour: 'numeric',
                  minute: 'numeric',
                  second:'numeric',
                  hour12: true,
              })}</span> */}
              {/* <IconButton  aria-label="account of current user"aria-controls="menu-appbar"aria-haspopup="true"
          onClick={handleMenu} color="inherit"> */}
              {/* <img alt="Remy Sharp" src={avatar} className='avatar' onClick={handleMenu}
            /> */}
              {/* <Menu id="menu-appbar" anchorEl={anchorEl}
              anchorOrigin={{ vertical: 'center', horizontal: 'left', }}
              keepMounted transformOrigin={{ vertical: 'center', horizontal: 'left', }}
              open={open} onClose={handleClose} onMouseLeave={handleClose} >
              <Container>
                <Typography variant="caption" display="block" gutterBottom>{getUser()}</Typography>
                <Typography variant="subtitle2">{getplaceSession()}</Typography>
                <Typography variant="subtitle2">{getDate()}</Typography>
              </Container>
            </Menu> */}
            </Toolbar>
          </AppBar>
        </Box>
      </div>
      <div style={{ marginTop: "-68px" }}>
        <div className="sidenav custom-scrollbar">
          <List component="nav" sx={{ width: "75px" }}>
            <ListItemButton
              selected={selectedIndex === 3}
              onClick={(event) => handleListItemClick(event, 12)}
            >
              <Col className="cntrtxt">
                <label className="listitemCss">
                  <RxDashboard fontSize={18} />
                  Dashboard
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              selected={selectedIndex === 3}
              onClick={(event) => handleListItemClick(event, 3)}
            >
              <Col className="cntrtxt">
                <label className="listitemCss">
                  <IoHomeOutline fontSize={18} />
                  Master
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              onMouseEnter={(e) => handleClosesidebar(e)}
              divider
              selected={selectedIndex === 7}
              onClick={(event) => handleListItemClick(event, 7)}
            >
              <Col className="cntrtxt ">
                <label className="listitemCss">
                  <IoPersonOutline fontSize={19} />
                  CheckList Approval By Manager
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              onMouseEnter={(e) => handleClosesidebar(e)}
              divider
              selected={selectedIndex === 8}
              onClick={(event) => handleListItemClick(event, 8)}
            >
              <Col className="cntrtxt ">
                <label className="listitemCss">
                  {" "}
                  <TbSend fontSize={15} />
                  CheckList Send To Party
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              onMouseEnter={(e) => handleClosesidebar(e)}
              divider
              selected={selectedIndex === 9}
              onClick={(event) => handleListItemClick(event, 9)}
            >
              <Col className="cntrtxt ">
                <label className="listitemCss">
                  <GoChecklist fontSize={22} />
                  CheckList Verify By Party
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              onMouseEnter={(e) => handleClosesidebar(e)}
              divider
              selected={selectedIndex === 4}
              onClick={(event) => handleListItemClick(event, 4)}
            >
              <Col className="cntrtxt ">
                <label className="listitemCss">
                  <FaRedRiver fontSize={22} />
                  Custom Activity
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              onMouseEnter={(e) => handleClosesidebar(e)}
              divider
              selected={selectedIndex === 5}
              onClick={(event) => handleListItemClick(event, 5)}
            >
              <Col className="cntrtxt ">
                <label className="listitemCss">
                  <IoBookmarksOutline fontSize={22} />
                  BE/SB Updation
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              onMouseEnter={(e) => handleClosesidebar(e)}
              divider
              selected={selectedIndex === 6}
              onClick={(event) => handleListItemClick(event, 6)}
            >
              <Col className="cntrtxt ">
                <label className="listitemCss">
                  <FaUber fontSize={22} />
                  Tracking
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              divider
              selected={selectedIndex === 11}
              onClick={(event) => handleListItemClick(event, 11)}
            >
              <Col className="cntrtxt">
                <label className="listitemCss">
                  <IoLayersOutline fontSize={22} />
                  Job Expenses
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              divider
              selected={selectedIndex === 1}
              onClick={(event) => handleListItemClick(event, 1)}
            >
              <Col className="cntrtxt">
                <label className="listitemCss">
                  <IoLayersOutline fontSize={22} />
                  Fund Request
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              selected={selectedIndex === 0}
              hidden={billing_hidden}
              onClick={(event) => handleListItemClick(event, 0)}
            >
              <Col className="cntrtxt">
                <label className="listitemCss">
                  {" "}
                  <ImFilesEmpty fontSize={22} />
                  Billing
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              divider
              selected={selectedIndex === 2}
              onClick={(event) => handleListItemClick(event, 2)}
            >
              <Col className="cntrtxt ">
                <label className="listitemCss">
                  <AiOutlineReconciliation fontSize={22} />
                  Reports
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton
              onMouseEnter={(e) => handleClosesidebar(e)}
              divider
              selected={selectedIndex === 10}
              hidden={billing_edit_hidden}
              onClick={(event) => handleListItemClick(event, 10)}
            >
              <Col className="cntrtxt ">
                <label className="listitemCss">
                  {" "}
                  <TbSend fontSize={15} />
                  Bill Edit
                </label>
              </Col>
            </ListItemButton>
            <Divider />
            <br></br>
            <Divider />
            <br></br>
            <Divider />
          </List>
        </div>
        <SidebarNav
          sidebar={Genarel}
          className="scrollbar scrollbar-secondary sidebarBodynavcss"
        >
          <ul>
            <li className="iconbar-header">Billings</li>
            {SidebarData.map((item, index) => {
              return <SubMenu item={item} key={index} />;
            })}
          </ul>
          <br></br>
          <Divider></Divider>
        </SidebarNav>
        <SidebarNav1
          sidebar={Report}
          className="scrollbar scrollbar-secondary sidebarBodynavcss"
        >
          <ul>
            <br />
            <h6 className="subMenu_header">REPORTS</h6>
          </ul>
          <ul hidden={Billreports_hidden}>
            <Button
              className="iconbar-header buttoncss"
              onClick={BillRepOnclick}
            >
              Bill Report{" "}
              <span className="arrowicon">
                <BiChevronsDown />
              </span>
            </Button>
            {billRepvisible ? (
              <div></div>
            ) : (
              BillReportData.map((item, index) => {
                return <SubMenu item={item} key={index} />;
              })
            )}
          </ul>
          <Divider></Divider>
          <ul>
            <Button
              className="iconbar-header buttoncss"
              onClick={FundRepOnclick}
            >
              Fund Report{" "}
              <span className="arrowicon">
                <BiChevronsDown />
              </span>
            </Button>
            {fundRepvisible ? (
              <div></div>
            ) : (
              FundReportData.map((item, index) => {
                return <SubMenu item={item} key={index} />;
              })
            )}
          </ul>
          <Divider></Divider>
          <ul>
            <Button
              className="iconbar-header buttoncss"
              onClick={DailyRepOnclick}
            >
              Daily Sts Report{" "}
              <span className="arrowicon">
                <BiChevronsDown />
              </span>
            </Button>
            {dailyStsRepvisible ? (
              <div></div>
            ) : (
              DailyReportData.map((item, index) => {
                return <SubMenu item={item} key={index} />;
              })
            )}
          </ul>
          <Divider></Divider>
          <ul>
            <Button
              className="iconbar-header buttoncss"
              onClick={OprRepOnclick}
            >
              Operation Report{" "}
              <span className="arrowicon">
                <BiChevronsDown />
              </span>
            </Button>
            {operRepvisible ? (
              <div></div>
            ) : (
              OpretionReportData.map((item, index) => {
                return <SubMenu item={item} key={index} />;
              })
            )}
          </ul>
          <br></br>
          <Divider></Divider>
          <ul>
            <Button
              className="iconbar-header buttoncss"
              onClick={dSR4RepOnclick}
            >
              DSR-STS{" "}
            </Button>
          </ul>
          <br></br>
          <Divider></Divider>
          <br></br>
          <br></br>
          <br></br>
        </SidebarNav1>
        <SidebarNav4
          sidebar={paymentExpence}
          className="scrollbar scrollbar-secondary sidebarBodynavcss"
        >
          <ul>
            <li className="iconbar-header">Payment Expenses</li>
            {PaymentExpencesData.map((item, index) => {
              return <SubMenu item={item} key={index} />;
            })}
          </ul>
          <br></br>
          <Divider></Divider>
          <br></br>
        </SidebarNav4>
        <SidebarNav2
          sidebar={Fund}
          className="scrollbar scrollbar-secondary sidebarBodynavcss"
        >
          <ul>
            <li className="iconbar-header">Payment EstimationData</li>
            {PaymentEstimationData.map((item, index) => {
              return <SubMenu item={item} key={index} />;
            })}
          </ul>
          <br></br>
          <Divider></Divider>
          <br></br>
        </SidebarNav2>
        <SidebarNav3
          sidebar={Master}
          className="scrollbar scrollbar-secondary sidebarBodynavcss"
        >
          <ul>
            <br />
            <h6 className="subMenu_header">MASTER</h6>
            <Button
              className="iconbar-header buttoncss"
              onClick={placeBarOnclick}
            >
              Place{" "}
              <span className="arrowicon">
                <BiChevronsDown />
              </span>
            </Button>
            {placevisible ? (
              <div></div>
            ) : (
              Place.map((item, index) => {
                return <SubMenu item={item} key={index} />;
              })
            )}
          </ul>
          <Divider></Divider>
          <ul>
            <Button
              className="iconbar-header buttoncss"
              onClick={BillingBarOnclick}
            >
              Billing{" "}
              <span className="arrowicon">
                <BiChevronsDown />
              </span>
            </Button>
            {billvisible ? (
              <div></div>
            ) : (
              Billing_Details.map((item, index) => {
                return <SubMenu item={item} key={index} />;
              })
            )}
          </ul>
          <Divider></Divider>
          <ul>
            <Button
              className="iconbar-header buttoncss"
              onClick={AccBarOnclick}
            >
              Accounts{" "}
              <span className="arrowicon">
                <BiChevronsDown />
              </span>
            </Button>
            {acc_visible ? (
              <div></div>
            ) : (
              Accounts.map((item, index) => {
                return <SubMenu item={item} key={index} />;
              })
            )}
          </ul>
          <br></br>
          <Divider></Divider>
          <br></br>
        </SidebarNav3>
      </div>
    </div>
  );
}

export default Home;
